import { createSlice } from "@reduxjs/toolkit";
import { ApiURLs, API_BASE_URL } from "../../common/url";
import { AsyncThunkAction } from "../asyncThunk";

const initialState = {
  newsFeedData: null,
};

export const getNewsUploadedGraphInfo = AsyncThunkAction(
  "/news/analytics/uploaded",
  API_BASE_URL + ApiURLs.Newsfeed.analytics.newsUploaded
);
export const getNewsTypeGraphInfo = AsyncThunkAction(
  "/news/analytics/type",
  API_BASE_URL + ApiURLs.Newsfeed.analytics.newsType
);

export const getNewsFeedData = AsyncThunkAction(
  "data/newsFeed",
  API_BASE_URL + ApiURLs.Newsfeed.getNews
);

const newsFeedSlice = createSlice({
  name: "newsFeed",
  initialState: initialState,
  reducers: {
    setNewsFeedData: (state, action) => {
      state.newsFeedData = action.payload.data;
    },
  },
});

export const { setNewsFeedData } = newsFeedSlice.actions;

export default newsFeedSlice.reducer;
